import { render } from "./SoftwareSkills.vue?vue&type=template&id=b83690e0"
import script from "./SoftwareSkills.vue?vue&type=script&lang=js"
export * from "./SoftwareSkills.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__